import type { EffectSection } from './sections';

export type ActiveEffect = { section: EffectSection; k: number; localTime: number; duration: number };

const EASE_SECONDS = 0.2;

/** 0..1 ramp in and out over 0.2 s, capped at a third of the section. */
export function easeEnvelope(localTime: number, duration: number): number {
  const ramp = Math.min(EASE_SECONDS, duration / 3);
  if (ramp <= 0) return 1;
  return Math.max(0, Math.min(1, localTime / ramp, (duration - localTime) / ramp));
}

/** Sections active at `timeSec` (half-open [start, end)), in array order,
 *  with their eased intensity k in 0..1. */
export function resolveActiveEffects(sections: ReadonlyArray<EffectSection> | undefined, timeSec: number | null): ActiveEffect[] {
  if (timeSec === null || !sections?.length) return [];
  const out: ActiveEffect[] = [];
  for (const section of sections) {
    if (timeSec < section.start || timeSec >= section.end) continue;
    const duration = section.end - section.start;
    const localTime = timeSec - section.start;
    const k = (section.intensity / 100) * (section.ease ? easeEnvelope(localTime, duration) : 1);
    if (k <= 0) continue;
    out.push({ section, k, localTime, duration });
  }
  return out;
}
